import { Label } from "@/components/ui/label";
import { NumberStepsInput } from "@/components/ui/number-steps-input";

interface NumberOfRoomsElementProps {
  onRoomNumberChange: (newRoomCount: number) => void;
  value: number;
}

export function NumberOfRoomsElement({
  onRoomNumberChange,
  value,
}: NumberOfRoomsElementProps) {
  return (
    <div className="flex w-[80px] flex-col">
      <Label className="mb-1.5">Rooms</Label>
      <NumberStepsInput value={value} onChange={onRoomNumberChange} min={1} />
    </div>
  );
}
